import { Col, Form } from "react-bootstrap";
import usePackage from "../../../../../hooks/usePackage";

function DetailForm({ shipments = [], prices }) {
  const { calculatePackagingPrice } = usePackage();

  const sumPackaging = shipments.reduce((sum, item) => {
    return (
      sum +
      calculatePackagingPrice({
        type: item.packaging,
        width: item.width,
        height: item.height,
        length: item.length,
        need: item.needPackaging,
      })
    );
  }, 0);

  const sumPrice = prices.reduce((sum, item) => sum + item.price, 0);

  return (
    <div className="d-flex flex-wrap">
      <Col xs={12} sm={6} md={4} lg={3} xxl={2} className="px-2">
        <Form.Label>تعداد:</Form.Label>
        <Form.Control value={shipments.length} type="number" disabled={true} />
      </Col>

      <Col xs={12} sm={6} md={4} lg={3} xxl={2} className="px-2">
        <Form.Label>مجموع هزینه بسته بندی:</Form.Label>
        <Form.Control
          type="text"
          value={sumPackaging.toLocaleString()}
          disabled={true}
        />
      </Col>

      <Col xs={12} sm={6} md={4} lg={3} xxl={2} className="px-2">
        <Form.Label>مجموع مبالغ استعلام:</Form.Label>
        <Form.Control
          type="text"
          disabled={true}
          value={sumPrice.toLocaleString()}
        />
      </Col>
    </div>
  );
}

export default DetailForm;
